<a (click)="closeSideNavIfRouterLink(routerLink())" class="router-menu-item" [routerLink]="routerLink()">
  <div (click)="toggleDropDownItems()" class="p-3 w-full flex justify-content-between">
    <div [style]="{'font-family': 'sans-serif'}" class="font-bold">
      {{ label() }}
    </div>
    @if(items()){
      <div>
        <i [class]="showDropDownItems() ? 'pi pi-angle-up' : 'pi pi-angle-down'"></i>
      </div>
    }
  </div>
</a>
@if(showDropDownItems()){
  <div @myInsertRemoveTrigger id="expandedDropDown"  class="flex flex-column pl-3">
    @for(item of items(); track item){
        <a [style]="{'font-family': 'sans-serif'}" (click)="closeSideNavIfRouterLink(item.routerLink)" class="router-menu-item p-3" [routerLink]="item.routerLink">
          {{ item.label }}
        </a>
    }
  </div>
}

